module.exports = __webpack_public_path__ + "45656808697d84299852fca71452c09a.jpg";